import { defineStore } from 'pinia'

export const store = defineStore('app', {
    state: () => ({
        user: null,
        token: null,
        uploadGroups: [],
        uploads: [],
        uploading: false,
        groups: [],
        noShare: false
    }),
    actions: {
        setNoShare (noShare) {
            this.noShare = noShare
        },
        setUser (user) {
            this.user = user
        },
        setToken (token) {
            this.token = token
        },
        addUploadGroup (group) {
            this.uploadGroups.push(group)
        },
        setUploadGroups (groups) {
            this.uploadGroups = groups
        },
        updateUploadGroup (idx, uploadGroup) {
            Object.assign(this.uploadGroups[idx], uploadGroup)
        },
        setUploadGroup (idx, key, value) {
            this.uploadGroups[idx][key] = value
        },
        updateUpload (groupIdx, uploadIdx, value) {
            Object.assign(this.uploadGroups[groupIdx].uploads[uploadIdx], value)
        },
        removeUploadGroupAt (idx) {
            this.uploadGroups.splice(idx, 1)
        },
        addUpload (upload) {
            this.uploads.push(upload)
        },
        removeUpload (upload) {
            const index = this.uploads.indexOf(upload)
            if (index > -1) {
                this.uploads.splice(index, 1)
            }
        },
        setUploads (uploads) {
            this.uploads = uploads
        },
        setUploading (uploading) {
            this.uploading = uploading
        },
        setGroups (groups) {
            this.groups = groups
        }
    }
})
